var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('email-editor',{attrs:{"project":_vm.project,"selected-sub-panels":_vm.selectedSubPanels,"template":"project-invitation"},on:{"change:translations":_vm.translationsChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }